import React, { useEffect, useState } from 'react';
import { Box, Card, CardActionArea, CardContent, CardMedia, Chip, Grid, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../utils/api';

const API_BASE = API_BASE_URL;

interface BlogPost { id: number; title: string; slug: string; excerpt?: string; coverImageUrl?: string; tags?: string[]; publishedAt?: string; featured?: boolean; authorName?: string; }

const Blog: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const res = await fetch(`${API_BASE}/blog`);
      if (res.ok) setPosts(await res.json());
    })();
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Blog</Typography>
      <Grid container spacing={2}>
        {posts.map(p => (
          <Grid key={p.id} item xs={12} sm={6} md={4}>
            <Card>
              <CardActionArea onClick={() => navigate(`/blog/${p.slug}`)}>
                {p.coverImageUrl && (
                  <CardMedia component="img" height="160" image={p.coverImageUrl} alt={p.title} />
                )}
                <CardContent>
                  <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                    {p.featured && <Chip size="small" color="warning" label="Featured" />}
                    {p.publishedAt && (
                      <Typography variant="caption" color="text.secondary">
                        {new Date(p.publishedAt).toLocaleDateString()}
                      </Typography>
                    )}
                  </Stack>
                  <Typography variant="h6">{p.title}</Typography>
                  {p.authorName && (
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                      By {p.authorName}
                    </Typography>
                  )}
                  {p.excerpt && <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>{p.excerpt}</Typography>}
                  <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    {(Array.isArray(p.tags) ? p.tags : []).map((t) => (
                      <Chip key={t} size="small" label={t} />
                    ))}
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Blog;